export default "__VITE_ASSET__22d606ee__"